<template>
  <span v-if="props.anchor" :id="props.anchor" class="anchor"></span>
  <div class="card" v-bind="$attrs">
    <h4 class="card-header text-uppercase bg-primary">Paiement</h4>
    <div class="card-body">
      <CheckboxComponent
        value-key="paymentEnabled"
        label="Activer le paiement obligatoire à l'inscription"
        :required="true"
        class="mb-3"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import * as zod from 'zod';

// const travel = defineModel<AdminTravel>({ required: true });
const validationSchema = defineModel<{ shape: zod.ZodRawShape, anchors?: Record<string, string | undefined> }>('validation-schema', { required: false, default: () => ({ shape: {} }) });

const props = defineProps<{
  anchor?: string
}>();

onMounted(() => {
  validationSchema.value = {
    shape: {
      paymentEnabled: zod.boolean({ message: 'Le choix du paiement est obligatoire' })
    },
    anchors: {
      paymentEnabled: props.anchor
    }
  };
});
</script>
